import React, { useState, useEffect } from "react"
import classNames from "classnames"
import styles from "./styles.module.css"

const ActivityIndicator = ({
  label = null,
  color = "orange",
  size = "small",
  stroke = null,
  timeout = 300,
}) => {
  const [pastDelay, setPastDelay] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setPastDelay(true)
    }, timeout)

    return () => clearTimeout(timer)
  }, [timeout])

  return pastDelay ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // Force it to column as in a row Safari will bounce
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div role="progressbar" className={styles.container}>
        <div className={classNames(styles.spinning, styles[size])}>
          <svg
            className={classNames({
              [styles[color]]: stroke === null,
              [styles[size]]: true,
            })}
            width="100%"
            height="100%"
            viewBox="0 0 32 32"
          >
            <circle
              className={styles["circle-bg"]}
              cx="16"
              cy="16"
              fill="none"
              r="14"
              strokeWidth="4"
              stroke={stroke}
            />
            <circle
              className={styles["circle-stroke"]}
              cx="16"
              cy="16"
              fill="none"
              r="14"
              strokeWidth="4"
              stroke={stroke}
            />
          </svg>
        </div>
      </div>

      {label && <div className={styles.label}>{label}</div>}
    </div>
  ) : null
}

export default ActivityIndicator
